import type {
  ITsdDocument,
  ITsdUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createTsdDocument,
  updateDocument: updateTsdDocument,
  deleteDocument: deleteTsdDocument,
} = makeDocumentService<ITsdDocument, ITsdUploadDocument>(
  '/api/tsddocuments',
  'tsdDocument'
)
